import {
  IconHome,
  IconListNumbers,
  IconAdjustmentsAlt,
  IconCirclePlusFilled,
  IconUsersPlus,
  IconUsers,
  IconClipboardList,
  IconCalculator,
} from '@tabler/icons-react';
import routes from '@/routes/index';
import { getRouteById } from '@/helpers/routes';

const navigation = [
  {
    label: routes.main.name,
    icon: IconHome,
    to: routes.main.path,
  },
  {
    label: routes.newProposal.name,
    icon: IconCirclePlusFilled,
    to: getRouteById(routes.newProposal.id, 'borrower')?.path,
  },
  {
    label: routes.proposals.name,
    icon: IconListNumbers,
    to: routes.proposals.path,
  },
  {
    label: routes.adminProposals.name,
    icon: IconClipboardList,
    to: routes.adminProposals.path,
  },
  {
    label: routes.clients.name,
    icon: IconUsers,
    to: routes.clients.path,
  },
  {
    label: routes.customizedMix.name,
    icon: IconCalculator,
    to: routes.customizedMix.path,
  },
  {
    label: routes.settings.name,
    icon: IconAdjustmentsAlt,
    to: routes.settings.path,
  },
  {
    label: routes.lead.name,
    icon: IconUsersPlus,
    to: routes.lead.path,
  },
];

export default navigation;
